import { render, staticRenderFns } from "./ChooseGeographicalLocationsEmpty.vue?vue&type=template&id=99dfa296&"
import script from "./ChooseGeographicalLocationsEmpty.vue?vue&type=script&lang=js&"
export * from "./ChooseGeographicalLocationsEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VCard,VForm,VList,VListTile,VTextField,VTextarea})
